import { Routes } from '@angular/router';
import { authGuard } from '../../auth/guards/auth.guard';
import { emailVerifiedGuard } from '../../auth/guards/email-verified.guard';
import { profileCompleteGuard } from '../../auth/guards/profile-complete.guard';
import { roleGuard } from '../../permissions/guards/role-guard';
import { acceptInvitationAuthGuard } from '../guards/accept-invitation-auth.guard';
import { acceptInvitationEmailVerifiedGuard } from '../guards/accept-invitation-email-verified.guard';
import { noOrgRequiredGuard } from '../guards/no-org-required.guard';
import { organizationGuard } from '../guards/organization.guard';
import { teamsEnabledGuard } from '../guards/teams-enabled.guard';

export const orgRoutes = [
  {
    path: 'create-organization',
    title: 'Create Organization',
    loadComponent: () => import('../pages/create-organization/create-organization'),
    canActivate: [authGuard, emailVerifiedGuard, profileCompleteGuard, noOrgRequiredGuard],
  },
  {
    path: 'members',
    title: 'Members',
    loadComponent: () => import('../pages/members/members'),
    canActivate: [authGuard, emailVerifiedGuard, organizationGuard, profileCompleteGuard],
  },
  {
    path: 'teams',
    title: 'Teams',
    loadComponent: () => import('../pages/teams/teams'),
    canActivate: [
      authGuard,
      emailVerifiedGuard,
      organizationGuard,
      profileCompleteGuard,
      teamsEnabledGuard,
    ],
  },
  {
    path: 'teams/:teamId',
    title: 'Team Details',
    loadComponent: () => import('../pages/team-details/team-details'),
    canActivate: [authGuard, emailVerifiedGuard, organizationGuard, profileCompleteGuard],
  },
  {
    path: 'invitations',
    title: 'Invitations',
    loadComponent: () => import('../pages/invitations/invitations'),
    canActivate: [
      authGuard,
      emailVerifiedGuard,
      roleGuard(['owner', 'attorney']),
      profileCompleteGuard,
    ],
  },
  {
    path: 'activity',
    title: 'Activity',
    loadComponent: () => import('../pages/activity-feed/activity-feed'),
    canActivate: [
      authGuard,
      emailVerifiedGuard,
      roleGuard(['owner', 'attorney']),
      profileCompleteGuard,
    ],
  },
  {
    path: 'settings',
    title: 'Settings',
    loadComponent: () => import('../pages/organization-settings/organization-settings'),
    canActivate: [
      authGuard,
      emailVerifiedGuard,
      roleGuard(['owner', 'attorney']),
      profileCompleteGuard,
    ],
  },
  {
    path: 'accept-invitation/:token',
    title: 'Accept Invitation',
    loadComponent: () => import('../pages/accept-invitation/accept-invitation'),
    canActivate: [acceptInvitationAuthGuard, acceptInvitationEmailVerifiedGuard],
  },
] as const satisfies Routes;
